import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import s from './ScheduleTaskForAwardedCompanyModal.scss'

const ScheduleTaskForAwardedCompanyModal = ({
  toggleShowScheduleTaskForAwardedCompany,
  showScheduleTaskForAwardedCompany,
  showScheduleTaskModal
}) => {
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showScheduleTaskForAwardedCompany}
        toggle={toggleShowScheduleTaskForAwardedCompany}
        size="md"
      >
        <ModalHeader toggle={toggleShowScheduleTaskForAwardedCompany} className={s.modalHeader} />
        <ModalBody>
          The Company that this opportunity was awarded to is not in your Current Clients list for
          this opportunity. If you&#39;d like to schedule a task to contact this client or send a
          proposal, click the button below.
        </ModalBody>
        <ModalFooter>
          <Button
            className={s.saveBtn}
            onClick={() => {
              toggleShowScheduleTaskForAwardedCompany()
              showScheduleTaskModal()
            }}
          >
            Schedule Task
          </Button>
          <Button color="secondary" onClick={toggleShowScheduleTaskForAwardedCompany}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ScheduleTaskForAwardedCompanyModal
